import React from "react";
import {SelectField} from "@atttomyx/react-components";
import {forms, objects} from "@atttomyx/shared-utils";

const BulkEmailForm = (props) => {
    const { unique, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="bulk-email-form">
        <div className="field">
            <SelectField
                required={true}
                label="Email"
                value={forms.sanitizeValue(data.email)}
                onChange={(value) => onChange("email", value)}
                options={unique.emails}
            />
        </div>
    </div>
}

export default BulkEmailForm;
